import './app.css';
import 'flowbite';
import './navbar';
import './current-year';
import { createIcons, icons } from 'lucide';

createIcons({icons});